"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SecureText/SecureTextExplainer.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);







var _secureText = require('shared/constants/secureText');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _TextKindLabel = require('./TextKindLabel'); var _TextKindLabel2 = _interopRequireDefault(_TextKindLabel);

// "comparison": what a secure text with link and an insecure text each do
// (More information). "insecureChat": opened from an insecure chat itself,
// a short note on this chat and what to do instead for PHI.






const PhiBadge = ({ isSecure, children }) => (
  _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, "secure-text--phi-badge", !isSecure && "secure-text--phi-badge--insecure"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
    ,  children 
  )
)

const HelpLink = () => (
  _react2.default.createElement('a', {
    className: "secure-text--explainer--help-link",
    href: _secureText.SECURE_TEXT_HELP_URL,
    target: "_blank",
    rel: "noopener noreferrer" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}

    ,  _secureText.SECURE_TEXT_HELP_LABEL , " →"
  )
)

const SecureTextExplainer = ({ variant = 'comparison' }) => {
  const titleId = _react.useId.call(void 0, )

  if (variant === 'insecureChat') {
    const { title, badge, lead, nextStep } = _secureText.INSECURE_CHAT_EXPLAINER
    return (
      _react2.default.createElement('div', { role: "dialog", 'aria-labelledby': titleId, className: "secure-text--explainer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
        , _react2.default.createElement('div', { className: "secure-text--explainer--title secure-text--explainer--title-row" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
          , _react2.default.createElement('span', { id: titleId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, _react2.default.createElement(_TextKindLabel2.default, { isSecure: false, label: title, __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}} ))
          , _react2.default.createElement(PhiBadge, { isSecure: false, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}},  badge )
        )
        , _react2.default.createElement('p', { className: "secure-text--explainer--lead", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}},  lead )
        , _react2.default.createElement('p', { className: "secure-text--explainer--next-step", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}},  nextStep )
        , _react2.default.createElement(HelpLink, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}} )
      )
    )
  }

  return (
    _react2.default.createElement('div', { role: "dialog", 'aria-labelledby': titleId, className: "secure-text--explainer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
      , _react2.default.createElement('div', { id: titleId, className: "secure-text--explainer--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
        ,  _secureText.SECURE_TEXT_EXPLAINER_TITLE 
      )
      ,  _secureText.SECURE_TEXT_EXPLAINER_CARDS.map(card => (
        _react2.default.createElement('div', { key: card.kind, className: "secure-text--explainer--card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
          , _react2.default.createElement('div', { className: "secure-text--explainer--card-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
            , _react2.default.createElement(_TextKindLabel2.default, { isSecure: card.kind === 'secure', label: card.title, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}} )
            , _react2.default.createElement(PhiBadge, { isSecure: card.kind === 'secure', __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}},  card.badge )
          )
          , _react2.default.createElement('ul', { className: "secure-text--explainer--points", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
            ,  card.points.map(point => _react2.default.createElement('li', { key: point, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}},  point )) 
          )
        )
      ))
      , _react2.default.createElement(HelpLink, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 73}} )
    )
  )
}

exports. default = SecureTextExplainer
